import { render, staticRenderFns } from "./MchTransferPage.vue?vue&type=template&id=2ff3bba2&scoped=true"
import script from "./MchTransferPage.vue?vue&type=script&lang=js"
export * from "./MchTransferPage.vue?vue&type=script&lang=js"
import style0 from "./MchTransferPage.vue?vue&type=style&index=0&id=2ff3bba2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3bba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff3bba2')) {
      api.createRecord('2ff3bba2', component.options)
    } else {
      api.reload('2ff3bba2', component.options)
    }
    module.hot.accept("./MchTransferPage.vue?vue&type=template&id=2ff3bba2&scoped=true", function () {
      api.rerender('2ff3bba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/MchTransferPage.vue"
export default component.exports